import { GuardData } from './guard.model';

const authGuard = (guardData: GuardData): boolean => {
  return !!guardData.store.auth.session;
};

export default authGuard;
